import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
    // eslint-disable-next-line no-console
    console.error('Supabase: defina REACT_APP_SUPABASE_URL e REACT_APP_SUPABASE_ANON_KEY no .env');
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
    auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});

/**
 * Monta o objeto `user` no formato que o app espera (auth + profile combinados).
 * Mantém compatibilidade com o que o PocketBase retornava (id, email, name, role, approved, created).
 */
export const fetchCurrentUser = async () => {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return null;

    const { data: profile } = await supabase
        .from('profiles')
        .select('name, role, approved')
        .eq('id', user.id)
        .single();

    return {
        id: user.id,
        email: user.email,
        created: user.created_at,
        name: profile?.name || user.user_metadata?.name || '',
        role: profile?.role || 'user',
        approved: !!profile?.approved,
    };
};

export const isUserLoggedIn = async () => {
    const { data: { session } } = await supabase.auth.getSession();
    return !!session;
};

export const logoutUser = () => supabase.auth.signOut();
